////////////////////////////////////////////////////////////////////
// This file contains configs that add analytics integrations     //
////////////////////////////////////////////////////////////////////

// Note: These come from the analytics asset nowadays by default.
//       To use this built-in configuration, you need to remove the overwrite from configHelper.js (mergeAnalyticsConfig func)

// Optional
// Note that Google Analytics might need advanced opt-out option / cookie consent
// depending on jurisdiction (e.g. EU countries), since it relies on cookies.
export const googleAnalyticsId = process.env.REACT_APP_GOOGLE_ANALYTICS_ID;

// Optional
// If you add this Plausible integration, you should first create an account in plausible.io
// This adds data-domains for Plausible script through environment variable: REACT_APP_PLAUSIBLE_DOMAINS
// https://plausible.io/docs/plausible-script#can-i-send-stats-to-multiple-dashboards-at-the-same-time
// You can add multiple domains separated by comma
// E.g. REACT_APP_PLAUSIBLE_DOMAINS=example1.com,example2.com
export const plausibleDomains = process.env.REACT_APP_PLAUSIBLE_DOMAINS;

// Optional — Google Ads tag. Two independent uses, see util/analytics.js:
// 1. REACT_APP_GOOGLE_ADS_ID alone loads the tag on every page (own gtag group `ads`) so
//    Google Ads builds website-visitor lists for remarketing. cowork24 prod:
//      REACT_APP_GOOGLE_ADS_ID=AW-17557550687
//    Set it on prod only — like the OpenAI pixel, dev/test traffic must not fill the lists.
// 2. With REACT_APP_GOOGLE_ADS_BOOKING_LABEL as well, the "Buchungsanfrage" conversion is
//    fired directly (send_to `${googleAdsId}/${googleAdsBookingLabel}`). Leave the label
//    UNSET while the GA4 `booking_request` event is imported into Google Ads — both together
//    count every booking twice.
//   REACT_APP_GOOGLE_ADS_BOOKING_LABEL=xxxxxxxxxxxxxxxxxx
// Note: REACT_APP_* vars are inlined at build time — rebuild/redeploy after changing them.
export const googleAdsId = process.env.REACT_APP_GOOGLE_ADS_ID;
export const googleAdsBookingLabel = process.env.REACT_APP_GOOGLE_ADS_BOOKING_LABEL;

// Optional — Reddit Ads Pixel (Conversion-Tracking für Reddit-Kampagnen).
// Die ID steht im Reddit Ads Events Manager unter "Pixel > Manuelle Einrichtung"
// und hat die Form `a2_...` (Advertiser-ID des Werbekontos).
//   REACT_APP_REDDIT_PIXEL_ID=a2_xxxxxxxxxxxx
// Ohne diese Variable bleibt das Pixel komplett inaktiv (kein Skript, keine Events).
// Geladen in util/DeferredAnalyticsScripts.js, Events in util/reddit.js.
// Hinweis: REACT_APP_* wird zur Build-Zeit ins Bundle inlined — nach dem Setzen
// neu deployen, ein Restart reicht nicht.
export const redditPixelId = process.env.REACT_APP_REDDIT_PIXEL_ID;

// Optional — OpenAI Ads Pixel (Conversion-Tracking für Werbung in ChatGPT).
// Die ID steht im OpenAI-Werbekonto beim Pixel (hier: Pixel „Buchungsanfrage",
// ID `TUGkFqu9VPunpAgvc6LwhE`) und ist eine 22-stellige Base62-Zeichenkette:
//   REACT_APP_OPENAI_PIXEL_ID=TUGkFqu9VPunpAgvc6LwhE
// Ohne diese Variable bleibt das Pixel komplett inaktiv (kein Skript, keine
// Events) — bewusst, damit Dev- und Test-Stage keine Schein-Conversions in das
// Produktiv-Pixel schreiben.
// Geladen in util/DeferredAnalyticsScripts.js, Events in util/openai.js.
// Hinweis: REACT_APP_* wird zur Build-Zeit ins Bundle inlined — nach dem Setzen
// neu deployen, ein Restart reicht nicht.
export const openAiPixelId = process.env.REACT_APP_OPENAI_PIXEL_ID;
